<mat-accordion togglePosition="before" class="faqs">
  <mat-expansion-panel *ngFor="let faq of faqs">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ faq.question}}</mat-panel-title>
    </mat-expansion-panel-header>
    <span [innerHTML]="faq.answer"></span>
  </mat-expansion-panel>
</mat-accordion>
